import { svg } from "../core/dom";

const icon = (size: number, color: string, strokeWidth: number, ...children: SVGElement[]): SVGElement =>
  svg(
    "svg",
    {
      width: String(size),
      height: String(size),
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: color,
      "stroke-width": String(strokeWidth),
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "aria-hidden": "true",
      style: { flexShrink: 0 },
    },
    ...children
  );

export const lockIcon = (color: string): SVGElement =>
  icon(
    15,
    color,
    2,
    svg("rect", { x: "3", y: "11", width: "18", height: "11", rx: "2" }),
    svg("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })
  );

export const checkIcon = (color: string): SVGElement =>
  icon(15, color, 2.5, svg("path", { d: "M20 6 9 17l-5-5" }));

export const clockIcon = (color: string): SVGElement =>
  icon(13, color, 2, svg("circle", { cx: "12", cy: "12", r: "9" }), svg("path", { d: "M12 7v5l3 2" }));

export const phoneIcon = (color: string): SVGElement =>
  icon(
    14,
    color,
    2,
    svg("path", {
      d: "M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z",
    })
  );

export const mailIcon = (color: string): SVGElement =>
  icon(
    14,
    color,
    2,
    svg("rect", { x: "2", y: "4", width: "20", height: "16", rx: "2" }),
    svg("path", { d: "m22 7-10 5L2 7" })
  );

export const chevronIcon = (expanded: boolean, color = "#323B4B"): SVGElement =>
  svg(
    "svg",
    {
      width: "7",
      height: "12",
      viewBox: "0 0 7 12",
      fill: "none",
      stroke: color,
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "aria-hidden": "true",
      style: {
        transform: expanded ? "rotate(90deg)" : "rotate(0deg)",
        transition: "transform 0.3s ease",
      },
    },
    svg("path", { d: "M1 1L6 6L1 11" })
  );

export const speakerIcon = (playing: boolean): SVGElement =>
  playing
    ? icon(
        16,
        "currentColor",
        2,
        svg("rect", { x: "6", y: "4", width: "4", height: "16" }),
        svg("rect", { x: "14", y: "4", width: "4", height: "16" })
      )
    : icon(
        16,
        "currentColor",
        2,
        svg("polygon", { points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5" }),
        svg("path", { d: "M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07" })
      );
